"use client";

import { Button } from "@ethera/ui/button";
import { NEXT_PUBLIC_SIGN_UP_URL } from "@guru/shared/config/env.client";
import { cn } from "@guru/shared/utils/cn";
import { ArrowRight } from "lucide-react";
import { trackMarketingEvent } from "@/lib/marketing/analytics";
import { usePersonaStore } from "./persona/persona-store";

interface TrialCTAProps {
  /** Where on the site this CTA lives, e.g. "hero", "calculator". */
  placement: string;
  label: string;
  size?: "sm" | "default" | "lg";
  variant?: "default" | "outline";
  className?: string;
}

/** Primary trial CTA — every instance reports its placement and persona. */
export function TrialCTA({
  placement,
  label,
  size = "lg",
  variant = "default",
  className,
}: TrialCTAProps) {
  const persona = usePersonaStore((state) => state.persona);

  return (
    <Button
      asChild
      size={size}
      variant={variant}
      className={cn(
        "gap-2",
        size === "lg" && "h-12 px-8",
        variant === "default" &&
          "bg-brand font-semibold text-brand-contrast transition-all duration-300 hover:scale-105 hover:bg-brand/90 hover:shadow-lg",
        className
      )}
    >
      <a
        href={NEXT_PUBLIC_SIGN_UP_URL}
        onClick={() => trackMarketingEvent("trial_cta_clicked", { placement, persona })}
      >
        {label}
        <ArrowRight className="h-4 w-4" aria-hidden="true" />
      </a>
    </Button>
  );
}
